import { render, staticRenderFns } from "./ColumnV1.vue?vue&type=template&id=638ab955&scoped=true&"
import script from "./ColumnV1.vue?vue&type=script&lang=js&"
export * from "./ColumnV1.vue?vue&type=script&lang=js&"
import style0 from "./ColumnV1.vue?vue&type=style&index=0&id=638ab955&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ab955",
  null
  
)

export default component.exports